import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { useTheme } from "@mui/styles";
import { useTranslation } from "react-i18next";

import ParkIcon from "@mui/icons-material/Park";
import BigBackgroundText from "../../components/TextComponents/BigBackgroundText";
import ContainedButton from "../../components/Buttons/ContainedButton";
import HeadlineText from "../../components/TextComponents/HeadlineText";
import IconWithText from "../../components/TextComponents/IconWithText";
import InfoText from "../../components/TextComponents/InfoText";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import React, { useState } from "react";

import {
  createCustomer,
  fetchCustomerByEmail,
  metaFieldIdSelector,
} from "../../redux/slices/customer";
import { updateMattressConfiguration } from "../../redux/slices/mattressConfiguration";
import SaveForLaterModal from "../../components/Modal/SaveForLaterModal";
import coverImage from "../../assets/images/Mask Group 46.png";
import homepageIcon1 from "../../assets/images/homepageIcon1.png";
import homepageIcon2 from "../../assets/images/user-gear-regular.png";
import homepageIcon3 from "../../assets/images/tree-deciduous-regular.png";

import { Link } from "react-router-dom";
import ViewCompactIcon from "@mui/icons-material/ViewCompact";
const HomeContent = () => {
  const loading = useSelector(state => state.customer.loading);
  const customer = useSelector(state => state.customer.customer);
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const theme = useTheme();

  //Media Queries
  const isSmallScreen = useMediaQuery({ query: "(max-width: 576px)" });
  const isMediumScreen = useMediaQuery({ query: "(max-width: 768px)" });
  const isLargeScreen = useMediaQuery({ query: "(max-width: 992px)" });
  const isExtraLargeScreen = useMediaQuery({ query: "(max-width: 1200px)" });

  const handleQueryCustomer = () => {
    dispatch(fetchCustomerByEmail("angelamerkel@gmail.com"));
  };

  const handleCreateCustomer = () => {
    const mockCustomer = {
      address: {
        address1: "487 Evergreen Rd. S",
        address2: "288",
        city: "Calgary",
        company: "",
        country: "Canada",
        countryCode: "CA",
        firstName: "John",
        lastName: "Doe",
        province: "Alberta",
        provinceCode: "",
        zip: "R1R1R1",
      },
      firstName: "Angela",
      lastName: "Merkel",
      email: "angelamerkel@gmail.com",
      // phone: "1234567890",
      mattressConfiguration: {
        model: 1,
        configuration: {
          weight: "heavy",
          sleepers: 2,
        },
      },
    };

    dispatch(createCustomer(mockCustomer));
  };

  const bulletPoints = [
    {
      title: t("Modular & Replaceable"),
      subTitle: t("Change & replace mattress components as needed."),
      component: () => (
        <img
          style={{ width: "30px", height: "28px" }}
          src={homepageIcon1}
        ></img>
      ),
      color: theme.COLORS.BLUE.blueGreen,
    },
    {
      title: t("Personalized"),
      subTitle: t("Personalize our evrbase to your exact needs"),
      component: () => (
        <img
          style={{ width: "30px", height: "28px" }}
          src={homepageIcon2}
        ></img>
      ),
      color: theme.COLORS.BLUE.lightBlue3,
    },
    {
      title: t("Sustainable"),
      subTitle: t("Recyclable and no throw away policies"),
      component: () => (
        <img
          style={{ width: "30px", height: "28px" }}
          src={homepageIcon3}
        ></img>
      ),
      color: theme.COLORS.GREEN.green,
    },
  ];
  return (
    <div className="row">
      {/*<SaveForLaterModal open={open} toggleModal={setOpen} />*/}
      <div className="evrbed-primary-col-5 m-2">
        <BigBackgroundText
          className="text-center"
          text={t("never")}
        ></BigBackgroundText>
        <HeadlineText text={t("buy another bed")}></HeadlineText>
        <InfoText text={t("Queen starting at $2495")}></InfoText>
        <div className="justify-content-md-center" style={{ marginTop: "3vh" }}>
          {bulletPoints.map(element => (
            <div
              key={element.title}
              className="row mt-3 justify-content-md-center justify-content-lg-start"
            >
              <div className="desktop-only" style={{ width: "10vw" }}></div>
              <IconWithText
                title={element.title}
                subTitle={element.subTitle}
                component={element.component}
                color={element.color}
              ></IconWithText>
            </div>
          ))}
        </div>
        <div className="row mt-4 justify-content-end">
          <Link
            to={"/our-story"}
            style={{
              color: theme.COLORS.WHITE.backgroundWhite,
              textDecoration: "none",
              fontFamily: "noto-sans",
              width: "auto",
            }}
          >
            <ContainedButton
              className="col-auto"
              color={theme.COLORS.BLUE.backgroundBlue}
              fontColor={theme.COLORS.BLUE.blueGreen1}
              variant="outlined"
              onClick={() => {}}
              styles={{ width: "320px" }}
            >
              {t("SEE WHY OUR CUSTOMERS LOVE US")}
            </ContainedButton>
          </Link>
          <Link
            to={"/why-evrbed"}
            style={{
              color: theme.COLORS.WHITE.backgroundWhite,
              textDecoration: "none",
              fontFamily: "noto-sans",
              width: "auto",
            }}
          >
            <ContainedButton
              className="col-auto"
              onClick={setOpen}
              styles={{ width: "170px" }}
            >
              {t("Why EVRBED")}
            </ContainedButton>
          </Link>
        </div>
      </div>
      <div className="col-1"></div>
      <div className="evrbed-col-5 row align-items-center">
        {/*  Image*/}
        <div className="col-10">
          <img style={{ width: "100%" }} src={coverImage} />
          <div
            style={{
              marginTop: "-10vh",
              marginLeft: "-3vw",
            }}
            className="row"
          >
            <div
              style={{
                background:
                  "transparent linear-gradient(160deg, #c5e35a 0%, #acd34c 100%) 0% 0% no-repeat padding-box",
                borderRadius: "0 120px 0 120px",
                width: "3vw",
                height: "15vh",

                opacity: 1,
                boxShadow: "4px 4px 0px #005DFF0F",
              }}
            ></div>
            <div
              style={{
                background:
                  "transparent linear-gradient(140deg, #ABE1FA 0%, #6398af 100%) 0% 0% no-repeat padding-box",
                borderRadius: "90px 0 90px 0",
                marginLeft: "10px",
                width: "10vw",
                height: "15vh",
                boxShadow: "4px 4px 0px #005DFF0F",
              }}
            ></div>
          </div>
        </div>

        <div className="col-2"></div>
      </div>
      {/*<Link to="/page-2/">Go to page 2</Link> <br />*/}
    </div>
  );
};

export default HomeContent;
